'use client';

import { useCallback, useEffect, useState } from 'react';

const SCROLLBAR_WIDTH_HYSTERESIS_PX = 16;

export function useContainerMinWidthLayout(minWidthPx: number) {
  const [containerElement, setContainerElement] =
    useState<HTMLDivElement | null>(null);
  const [meetsMinWidth, setMeetsMinWidth] = useState(true);

  const setContainerRef = useCallback((node: HTMLDivElement | null) => {
    setContainerElement((previous) => (previous === node ? previous : node));
  }, []);

  useEffect(() => {
    if (!containerElement) {
      return;
    }

    const updateLayout = () => {
      const width = containerElement.clientWidth;

      setMeetsMinWidth((currentlyMeetsMinWidth) => {
        if (currentlyMeetsMinWidth) {
          return width >= minWidthPx;
        }

        return width >= minWidthPx + SCROLLBAR_WIDTH_HYSTERESIS_PX;
      });
    };

    updateLayout();

    const resizeObserver = new ResizeObserver(updateLayout);

    resizeObserver.observe(containerElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerElement, minWidthPx]);

  return {
    setContainerRef,
    meetsMinWidth,
  };
}
